<template>
  <Header v-if="showHeader" />
  <v-main>
    <router-view></router-view>
  </v-main>
  
  <!-- Globales Lade-Overlay -->
  <v-overlay
    :model-value="isLoading"
    class="align-center justify-center"
    persistent
    scrim="rgba(0,0,0,0.5)"
    z-index="9999"
  >
    <v-progress-circular
      color="primary"
      indeterminate
      size="64"
      width="6"
    ></v-progress-circular>
  </v-overlay>
  <!--Footer /-->
</template>

<script>
import Header from '../views/HeaderView.vue';
//import Footer from './Footer.vue';
import {useRoute, useRouter} from "vue-router";
import {useStore} from 'vuex';
import {computed, onMounted, ref, watch} from "vue";
import APIServiceRestDB from "@/services/MesskursBackendService";
import APIService from "@/services/APIService";

export default {
  components: {
    Header,
    //Footer
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const caseTitle = ref("-");
    const router = useRouter();

    // Logout via URL parameter logout=1
    const checkLogoutParameter = () => {
      if (route.query.logout === '1') {
        store.dispatch('logout');
        router.push('/login');
      }
    };

    const captureExternalFrameParameter = () => {
      if (route.query.fromapp === '1' || route.query.iframe === '1') {
        store.dispatch('updateExternalFrame', true);
      }
    };

    // Funktion zum Erfassen und Aktualisieren des Case-Parameters
    const captureCaseParameter = async () => {
      let caseId = route.query.case;
      let sessionId = route.query.session || route.params.sessionId;

      // if on selection page or evaluation, do not enforce a default case/session
      if (route.path.startsWith('/selection') || (route.path.startsWith('/evaluation') && route.name !== 'EvaluationDetail')) {
        return;
      }

      // Check if user is on mode pages (Lernen, Ueben, Test)
      const isModePage = ['Lernen', 'Ueben', 'Test'].includes(route.name);

      // If no session is active for mode pages, redirect to selection
      if (isModePage && !sessionId && !store.state.sessionId) {
        router.push('/selection');
        return;
      }

      // If no caseId/sessionId in URL, but we have them in store, use those
      if (!caseId && store.state.caseId) {
        caseId = store.state.caseId;
      }
      if (!sessionId && store.state.sessionId) {
        sessionId = store.state.sessionId;
      }

      if (sessionId) {
        store.dispatch('updateSessionId', sessionId);
        const sessionTmp = await APIServiceRestDB.getSession(sessionId);
        if (sessionTmp) {
          store.dispatch('updateSession', sessionTmp);
          if (!caseId) {
            caseId = sessionTmp.object || sessionTmp.caseId || sessionTmp.objectSpecId || sessionTmp.toolbox || null;
          }

          // Load C-Learning Course if associated
          if (sessionTmp.course) {
            const courseData = await APIService.getCourse(sessionTmp.course, true);
            if (courseData) {
              store.dispatch('updateCourse', courseData);
            }
          }
        }
      }

      // If no case is provided, try resolving it from the session.
      // Die Logik darüber lädt die Session inzwischen immer, wenn eine sessionId vorhanden ist.

      // Default course ID if no course is set in store or session
      // This is now optional as we have a course selection, 
      // but we keep it for now if needed for standalone without selection.
      // const DEFAULT_COURSE_ID = "6970797ccf53380027d79262";
      if (!store.state.course && !route.path.startsWith('/evaluation') && !route.path.startsWith('/selection')) {
        // console.log("No course found, loading default course ID:", DEFAULT_COURSE_ID);
        // const defaultCourseData = await APIService.getCourse(DEFAULT_COURSE_ID, true);
        // if (defaultCourseData) {
        //   store.dispatch('updateCourse', defaultCourseData);
        // }
      }

      // Standard Case-Logik (Fallback wenn kein Case aus Sitzung ermittelt wurde)
      
      if (caseId) {
        // Annahme: Die Aktion 'updateCaseId' ist in deinem Vuex Store definiert
        store.dispatch('updateCaseId', caseId);
        const caseTmp = await APIServiceRestDB.getObjectWithId(caseId);
        if(caseTmp){
          store.dispatch('updateCase', caseTmp);
        } else {
          // Fallback check if it's actually a specification ID
          const specTmp = await APIServiceRestDB.getToolbox(caseId);
          if (specTmp && !Array.isArray(specTmp)) {
             // Create a dummy case object if we found specs directly
             store.dispatch('updateCase', { _id: caseId, objectSpecId: caseId, title: specTmp.title || "Fallback Case" });
          } else {
             console.error("Case ID " + caseId + " could not be resolved in any collection.");
          }
        }
      }
    };

    // Beobachte Änderungen am Pfad und Query-Parameter
    watch(() => [route.path, route.query.case, route.query.session, route.params.sessionId, route.query.logout], () => {
      checkLogoutParameter();
      captureExternalFrameParameter();
      captureCaseParameter();
    });

    // Überprüfe den Parameter, wenn die Komponente gemountet wird
    onMounted(() => {
      checkLogoutParameter();
      captureExternalFrameParameter();
      captureCaseParameter();
    });

    return { 
      caseTitle, 
      showHeader: computed(() => store.state.showHeader),
      isLoading: computed(() => store.state.isLoading)
    };
  }
};
</script>
